import {Pressable, StyleSheet, useWindowDimensions, View} from "react-native";
import {Image} from "expo-image";
import {BASE_URL} from "@/lib/constants";
import {Color} from "@/lib/styles";
import Icon from "@/lib/components/Icon";

type Props = {
    source?: string,
    editBackgroundColor?: string,
    editBorderColor?: string,
    onPressEdit?: () => any,
}

export default function CardImage({source, editBackgroundColor, editBorderColor, onPressEdit}: Props) {
    const backgroundColor = editBackgroundColor || Color.BackgroundContainer;
    const borderColor = editBorderColor || Color.FadedText;
    const dims = useWindowDimensions();

    function editWidget() {
        return (
            <Pressable style={[styles.editable, {borderColor}]} onPress={onPressEdit}>
                <Icon kind={"camera"} size={dims.width / 8} color={Color.PrimaryText}/>
            </Pressable>
        )
    }

    const editWidgetNoImageStyle = {
        backgroundColor,
    }

    return (
        <View style={styles.cardImageContainer}>
            {!!source && <Image style={[styles.cardImage]} source={BASE_URL + source}></Image>}
            {!source && !!onPressEdit && <View style={[styles.cardImage, editWidgetNoImageStyle]}></View>}
            {!!onPressEdit && editWidget()}
        </View>
    )
}

const styles = StyleSheet.create({
    cardImageContainer: {
        width: "100%",
        flexDirection: "row",
    },
    cardImage: {
        aspectRatio: 2.5,
        flex: 1,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
    },
    editable: {
        position: "absolute",
        justifyContent: "center",
        alignItems: "center",
        top: 16,
        bottom: 16,
        left: 16,
        right: 16,
        borderWidth: 1,
        borderColor: Color.FadedText,
        borderRadius: 16,
        borderStyle: "dashed",
    }
});